import React from 'react';

export class AppDetailLoading extends React.Component {

  displayLoadingBlank(className = "") {
    return <span className={`loading-span ${className}`}/>
  }

  render () {
    return(
      <section className="app-detail-banner">
        <div className="container">
          <div className="row">
            <div className="app-detail-banner-icon col-3">
              <img
                src="/images/placeholder-image.png"
                width="100%"
                height="auto"
              />
            </div>
            <div className="app-detail-banner-text col-9">
              <h1>{this.displayLoadingBlank()}</h1>
              <div className="col-4">
                <dl className="app-detail-banner-definitions">
                  <div>
                    <dt>Platform:</dt>
                    <dd>{this.displayLoadingBlank()}</dd>
                  </div>
                </dl>
                <div className="app-detail-banner-ratings">
                  <span className="app-detail-banner-stars" />
                  <span className="app-detail-banner-count">
                    {this.displayLoadingBlank()}
                  </span>
                </div>
              </div>
              <div className="col-4">
                <dl className="app-detail-banner-definitions">
                  <div>
                    <dt>Views:</dt>
                    <dd>{this.displayLoadingBlank()}</dd>
                  </div>
                  <div>
                    <dt>Downloads:</dt>
                    <dd>{this.displayLoadingBlank()}</dd>
                  </div>
                </dl>
              </div>
            </div>
          </div>
        </div>
      </section>
    );
  }
}